import React from "react";
import "./Campaigns.css";

export default function CampaignList({
  campaigns = [],
  onEdit,
  onDelete,
  onToggleStatus,
  onManageRules,
}) {

  const formatDate = (date) => {
    if (!date) return "—";

    try {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return date;
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "ACTIVE":
        return "status-active";
      case "INACTIVE":
        return "status-inactive";
      case "SCHEDULED":
        return "status-scheduled";
      case "EXPIRED":
        return "status-expired";
      default:
        return "status-default";
    }
  };

  if (!campaigns.length) {
    return (
      <div className="empty-state">
        <h3>No Campaigns Found</h3>
        <p>Create your first campaign to promote products.</p>
      </div>
    );
  }

  return (
    <div className="campaign-list">

      {campaigns.map((campaign) => {

        const hasRule = campaign.hasRule;
        const ruleCount = campaign.ruleCount ?? 0;
        const productCount = campaign.productCount ?? 0;

        const ready = hasRule && productCount > 0;

        return (

          <div
            key={campaign.id}
            className="campaign-card"
          >

            {/* HEADER */}

            <div className="campaign-header">

              <div>

                <h3 className="campaign-title">
                  {campaign.name}
                </h3>

                <p className="campaign-description">
                  {campaign.description || "No description available"}
                </p>

              </div>

              <span
                className={`campaign-status ${getStatusClass(
                  campaign.status
                )}`}
              >
                {campaign.status}
              </span>

            </div>

            {/* DETAILS */}

            <div className="campaign-details">

              <div>
                <strong>Type</strong>
                <span>{campaign.campaignType}</span>
              </div>

              <div>
                <strong>Products</strong>
                <span>
                  {productCount} Product{productCount !== 1 ? "s" : ""}
                </span>
              </div>

              <div>
                <strong>Rules</strong>

                <span
                  className={
                    hasRule
                      ? "status-active"
                      : "status-inactive"
                  }
                >
                  {hasRule
                    ? `✅ ${ruleCount} Rule${ruleCount !== 1 ? "s" : ""}`
                    : "❌ No Rules"}
                </span>

              </div>

              <div>
                <strong>Campaign Health</strong>

                <span
                  className={
                    ready
                      ? "status-active"
                      : hasRule
                        ? "status-scheduled"
                        : "status-inactive"
                  }
                >
                  {ready
                    ? "🟢 Ready"
                    : hasRule
                      ? "🟡 No Products"
                      : "🔴 No Rules"}
                </span>

              </div>

              <div>
                <strong>Coupon</strong>
                <span>
                  {campaign.couponEnabled
                    ? campaign.couponCode || "Enabled"
                    : "Not Enabled"}
                </span>
              </div>

              <div>
                <strong>Start Date</strong>
                <span>{formatDate(campaign.startDate)}</span>
              </div>

              <div>
                <strong>End Date</strong>
                <span>{formatDate(campaign.endDate)}</span>
              </div>

            </div>

            {/* ACTIONS */}

            <div className="campaign-actions">

              <button
                className="btn-secondary"
                onClick={() => onEdit?.(campaign)}
              >
                ✏ Edit
              </button>

              <button
                className="btn-info"
                onClick={() => onManageRules?.(campaign)}
              >
                {hasRule
                  ? "⚙ Manage Rules"
                  : "➕ Create Rule"}
              </button>

              <button
                className={
                  campaign.status === "ACTIVE"
                    ? "btn-warning"
                    : "btn-success"
                }
                onClick={() => onToggleStatus?.(campaign)}
              >
                {campaign.status === "ACTIVE"
                  ? "Deactivate"
                  : "Activate"}
              </button>

              <button
                className="btn-danger"
                onClick={() => onDelete?.(campaign)}
              >
                🗑 Delete
              </button>

            </div>

          </div>

        );

      })}

    </div>
  );
}